import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Clock, TrendingUp, HeartHandshake } from 'lucide-react';
// 👉 EDITÁ EL CONTENIDO DE ESTA SECCIÓN ABAJO
export const benefitsContent = {
  title: 'Qué vas a lograr con este material',
  benefits: [{
    icon: 'Clock',
    title: 'Ahorrar tiempo valioso',
    description: 'Dejá de armar fichas desde cero. Usá ese tiempo para planificar mejores sesiones o disfrutar de tu vida personal.'
  }, {
    icon: 'TrendingUp',
    title: 'Elevar tu nivel profesional',
    description: 'Entregá materiales clínicos de calidad premium que justifiquen el valor de tus sesiones y te diferencien.'
  }, {
    icon: 'HeartHandshake',
    title: 'Mejorar el vínculo con las familias',
    description: 'Facilitá el acompañamiento del proceso con recursos visuales claros que las familias puedan aplicar en casa.'
  }]
};
const iconMap: Record<string, React.ElementType> = {
  Clock,
  TrendingUp,
  HeartHandshake
};
export function Benefits() {
  return <section className="py-24 px-4 bg-[#0f0f0f]" data-id="element-32">
      <div className="max-w-6xl mx-auto" data-id="element-33">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-serif text-center mb-16 text-brand-light" data-id="element-34">
          {benefitsContent.title}
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-35">
          {benefitsContent.benefits.map((benefit, index) => {
          const IconComponent = iconMap[benefit.icon] || Clock;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="text-center flex flex-col items-center" data-id="element-36">
                <div className="w-16 h-16 rounded-full bg-brand-accent/10 flex items-center justify-center mb-6" data-id="element-37">
                  <IconComponent className="w-8 h-8 text-brand-accent" data-id="element-38" />
                </div>
                <h3 className="text-2xl font-serif mb-4 text-brand-light" data-id="element-39">
                  {benefit.title}
                </h3>
                <p className="text-brand-light/70 font-sans leading-relaxed" data-id="element-40">
                  {benefit.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}